import React from 'react';
import PropTypes from 'prop-types';
import { Form, Formik } from 'formik';

import { createFormValidationFn, createInitialValues } from 'client/helpers/formikHelpers';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREEN,
  SR_BUTTON_THEME_ADOBE_GREY,
} from 'client/components/SrButton/SrButton';
import SrSeparator from 'client/components/SrSeparator';
import SrDarkModal from 'client/components/SrDarkModal';
import { SR_INFO_OPTION_CHECKBOX_THEME_ADOBE_UP } from 'client/components/SrInfoOptionCheckbox/SrInfoOptionCheckbox';
import SrFormikField, {
  SR_FIELD_THEME_ADOBE_UTILITY_PROFIT,
} from 'client/components/SrFormikField';
import SrModalContent from 'client/components/SrModalContent';

const getFormFields = ({ utilityPartnerList }) => {
  return [
    {
      id: 'utilityPartnerIds',
      type: 'info_checkbox_multi',
      title: 'Platforms they can access',
      subtitle:
        'They can switch between platforms using their top right account settings dropdown.',
      properties: {
        choices: utilityPartnerList.map(({ id, name }) => ({
          label: name,
          value: id,
          theme: SR_INFO_OPTION_CHECKBOX_THEME_ADOBE_UP,
        })),
      },
      validations: ['nonEmptyArray::Please select at least one platform.'],
    },
  ];
};

const SrUtilityProfitPartnerUserGroupModal = ({
  utilityUser,
  utilityPartnerList,
  utilityPartnerIds,
  onSubmit,
  onClose,
}) => {
  return (
    <SrDarkModal onClose={onClose}>
      <SrModalContent style={{ width: 412, marginTop: 4 }}>
        <SrBox display="flex" alignItems="center" justifyContent="center" flexDirection="column">
          <SrText
            weight="800"
            font="greycliff"
            fontSize="25px"
            lineHeight="30px"
            letterSpacing="0.5"
            align="center"
          >
            Edit platforms
            <br />
            {utilityUser ? `${utilityUser.firstName} ${utilityUser.lastName}` : 'Team Member'} can
            access.
          </SrText>
        </SrBox>
        <SrSeparator marginTop="20px" marginBottom="8px" />
        <SrBox display="flex" alignItems="center" justifyContent="center" flexDirection="column">
          <Formik
            initialValues={createInitialValues({
              formFields: getFormFields({
                utilityPartnerList,
              }),
              defaultValues: {
                utilityPartnerIds,
              },
            })}
            validate={(formValues) => {
              return createFormValidationFn(
                getFormFields({
                  utilityPartnerList,
                }),
              )(formValues);
            }}
            onSubmit={(formValues) => {
              onSubmit(formValues.utilityPartnerIds);
              onClose();
            }}
            render={(formikBag) => {
              const formFields = getFormFields({
                utilityPartnerList,
              });

              return (
                <Form style={{ width: '100%', maxWidth: '350px' }}>
                  <SrBox margin="22px 0 27px">
                    {formFields.map((formField) => {
                      return (
                        <SrFormikField
                          key={formField.id}
                          formField={formField}
                          formikBag={formikBag}
                          className={SR_FIELD_THEME_ADOBE_UTILITY_PROFIT}
                        />
                      );
                    })}
                  </SrBox>
                  <SrBox>
                    <SrButton
                      type="submit"
                      theme={SR_BUTTON_THEME_ADOBE_GREEN}
                      disabled={!formikBag.isValid}
                      hasBoxShadow
                    >
                      Save
                    </SrButton>
                    <SrBox height="12px" />
                    <SrButton
                      theme={SR_BUTTON_THEME_ADOBE_GREY}
                      type="button"
                      margin="12px 0px"
                      onClick={onClose}
                      hasBoxShadow
                    >
                      Cancel
                    </SrButton>
                  </SrBox>
                </Form>
              );
            }}
          />
        </SrBox>
      </SrModalContent>
    </SrDarkModal>
  );
};

SrUtilityProfitPartnerUserGroupModal.propTypes = {
  utilityUser: PropTypes.object,
  utilityPartnerList: PropTypes.array,
  onClose: PropTypes.func,
};

SrUtilityProfitPartnerUserGroupModal.displayName = 'SrUtilityProfitPartnerUserGroupModal';

export default SrUtilityProfitPartnerUserGroupModal;
